import React from 'react';
import LivingIntegral from '../components/LivingIntegral';

function LivingIntegralPage() {
  return <LivingIntegral />;
}

export default LivingIntegralPage;
